module.exports = __webpack_public_path__ + "static/img/service01.592af4b7.png";